import React, { useState,useEffect } from "react";
import { LOGOUT_MESSAGE } from './../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import * as RouteInfo from './../RouteConstents';
import { toast } from 'react-toastify';
import jwt_decode from "jwt-decode";

const SideBarLayout = () => {

    const navigate = useNavigate();
    const [userName, setUserName] = useState('');
    const [phone, setPhone] = useState('');
    const [courseName, setCourseName] = useState('');
    const [batchName, setBatchName] = useState('');
    const [showNavigationView, setShowNavigationView] = useState(0);

    const logout = () => {
        localStorage.removeItem('userInfo');
        toast.success(LOGOUT_MESSAGE); 
        navigate('/');
        
    };

    useEffect(
        () => {
        let userToken = JSON.parse(localStorage.getItem('userInfo'));

        let userInfo =  jwt_decode(userToken)    

        setUserName(userInfo.full_name);
        setPhone(userInfo.phone);
        setCourseName(userInfo.course_name);
        setBatchName(userInfo.batch_name);

       
        
    },[true]); 

    const showNavigation = (e) => {
        
        if(showNavigationView === 0) {
            document.body.classList.add('overlay-open');
            setShowNavigationView(1);
        } else {
            document.body.classList.remove('overlay-open');
            setShowNavigationView(0); 
        } 

    }

    
    return (

        <section>
            <aside id="leftsidebar" className="sidebar">
                <div className="user-info bg-cyan">
                    <div className="row">
                        <div className="col-xs-3 text-center">
                            <div className="image">
                                <img src="/assets/img/user.png" width="60" height="60" alt="User" />
                            </div>
                        </div>
                        <div className="col-xs-9">
                            <div className="name">{userName}</div>
                            <div className="phone">+91 {phone}</div>
                            <div className="name">{courseName}</div>
                            <div className="name">{batchName}</div>
                        </div>
                    </div>
                </div>

                <div className="menu">
                    <ul className="list">
                        
                        <li className="active">
                            <Link to={RouteInfo.ROUTE_DASHBOARD} onClick={showNavigation} >
                                <i className="material-icons">home</i>
                                <span>Dashboard</span>
                            </Link>
                        </li>
                        <li>
                            <Link to={RouteInfo.ROUTE_TEST_SERIES_PAGE} onClick={showNavigation} >
                                <i className="material-icons">widgets</i>
                                <span>Test Series</span>
                            </Link>
                        </li>
                        {/* <li>
                            <Link to={RouteInfo.ROUTE_PRACTISE_TEST_PAGE} onClick={showNavigation} >
                                <i className="material-icons">widgets</i>
                                <span>Quizzes</span>
                            </Link>
                        </li> */}
                        <li>
                            <Link to={RouteInfo.ROUTE_VIDEO_PAGE} onClick={showNavigation} >
                                <i className="material-icons">widgets</i>
                                <span>Knowledge Section</span>
                            </Link>
                        </li>
                        
                        <li className="header">My Account</li>
                        <li>
                            <Link to={RouteInfo.ROUTE_MY_PROFILE} onClick={showNavigation} >
                                <i className="material-icons">text_fields</i>
                                <span>My Profile</span>
                            </Link>
                        </li>
                        {/* <li>
                            <Link to={RouteInfo.ROUTE_MY_PROFILE} onClick={showNavigation} >
                                <i className="material-icons">text_fields</i>
                                <span>Notifications</span>
                            </Link>
                        </li> */}
                        {/* <li>
                            <Link to={RouteInfo.ROUTE_MY_PROFILE} onClick={showNavigation} >
                                <i className="material-icons">text_fields</i>
                                <span>Change Email</span>
                            </Link>
                        </li> */}


                        <li>
                            <Link  onClickCapture={logout} className="curser_pointer">
                                <i className="material-icons col-red">donut_large</i>
                                <span>Logout</span>
                            </Link>
                        </li>

                    </ul>
                </div>
            </aside>
        </section>
    
    );

}

export default SideBarLayout;